type LandingRoute = {
  key?: string;
  path?: string | null;
  showInMenu?: boolean;
  children?: LandingRoute[];
};

type LandingAbility = {
  can: (action: string, subject: string) => boolean;
};

type MenuPath = {
  keys: (string | undefined)[];
  fullPath: string;
  showInMenu?: boolean;
};

const indexChain = (route: LandingRoute): LandingRoute[] => {
  const index = route.children?.find(({ path }) => path === '');
  return index ? [route, ...indexChain(index)] : [route];
};

const menuPaths = (routes: LandingRoute[], basePath = ''): MenuPath[] =>
  routes.flatMap((route) => {
    const { path, showInMenu, children } = route;
    if (path === undefined || path === null) return [];
    const fullPath = path ? `${basePath}/${path}` : basePath;
    const keys = indexChain(route).map(({ key }) => key);
    return [{ keys, fullPath, showInMenu }, ...menuPaths(children ?? [], fullPath)];
  });

export const firstEnabledPath = (routes: LandingRoute[], ability: LandingAbility): string | undefined =>
  menuPaths(routes).find(({ keys, fullPath, showInMenu }) => showInMenu
    && fullPath
    && !fullPath.includes(':')
    && keys.every((key) => key
      && ability.can('view', key)
      && ability.can('enabled', key)))?.fullPath;
